export default "__VITE_ASSET__BFbN8aOj__"